import { accessTokenSerializer } from "../../utils";
import { usePost } from "../usePost";

export const usePostRefreshToken = () =>
  usePost({
    url: `${process.env.REACT_APP_BACKEND_URL}/api/v2/refresh`,
    serializer: accessTokenSerializer,
  });
